var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Benefits'),_c('benefit-info-card',{attrs:{"title":_vm.bankDetailsTitle,"data":_vm.bankDetailsInfo,"itemIndex":"2","get_error":_vm.get_error,"reloadBankDetails":_vm.reload}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }